import './services-product.scss'
import { clsx } from 'clsx'
import React from 'react'

import { ProductServices_Slider } from '@/features/product-services/ui/ProductServices_Slider/ProductServices_Slider'

import { TService } from '../../lib/types'

import cl from './ProductServices_List.module.scss'

type ServiceListProps = {
	allServices: TService[]
	relatedId: number
	activeServices?: string[]
	isProduct?: boolean
}
export const ProductServices_List = ({
	allServices,
	relatedId,
	activeServices,
	isProduct
}: ServiceListProps): JSX.Element => {
	const filteredServices = allServices.filter(service => !!service.VARIANTS.length)

	return (
		<section className={clsx(cl.root, { [cl.isProduct]: isProduct })} id="servicesProduct">
			<p className={cl.titleTop}>Добавить услуги</p>
			{filteredServices.map(({ ID, VARIANTS, TITLE }) => (
				<div key={ID} className={cl.row} id={TITLE === 'Сервисы и страхование' ? `services` : `cards`}>
					<div className={cl.wrap}>
						<p className={cl.title} id={TITLE === 'Сервисы и страхование' ? 'policy' : undefined}>
							{TITLE}
						</p>
						<ProductServices_Slider rows={VARIANTS} relatedId={relatedId} activeServices={activeServices} />
					</div>
				</div>
			))}
		</section>
	)
}
